





























































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";

import { API_URL } from "../global";
import {
  pageDataType,
  sociallinkItem,
  settinglinkItem,
  RmainMenuItem,
} from "../types";
import {
  FETCH_RMAIN_MENU,
  FETCH_SOCIAL,
  FETCH_SETTING,
} from "../store/actions.names";
import { pageData } from "../store/pageData";
import axios from "axios";
import {
  TweenMax,
  TimelineLite,
  Power3,
  Power4,
  Power1,
  Power2,
  TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";

@Component({
  name: "FooterCard",
})
export default class FooterCard extends Vue {
  @Getter("rmainMenu") public rmainMenu!: RmainMenuItem[];
  @Getter("sociallink") public sociallink!: sociallinkItem[];
  @Getter("settinglink") public settinglink!: settinglinkItem[];
  @Getter("pageData") public pageData!: pageDataType;
  @Getter("pageType") public pageType!: string | null;
  @Action(FETCH_RMAIN_MENU) public [FETCH_RMAIN_MENU]: any;
  @Action(FETCH_SOCIAL) public [FETCH_SOCIAL]: any;
  @Action(FETCH_SETTING) public [FETCH_SETTING]: any;
  public footerAnim() {
    var mq = window.matchMedia("(min-width: 1900px)");
    const ft = new TimelineMax()
      .staggerFrom(
        ".footer-about-us h3",
        0.5,
        {
          yPercent: 20,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.4"
      )
      .staggerFrom(
        ".footer-about-us p",
        0.5,
        {
          yPercent: 20,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.3"
      )
      .staggerFrom(
        ".sq-footer-social a",
        0.5,
        {
          xPercent: -20,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.5"
      )
      .staggerFrom(
        ".footer-useful-links h3",
        0.5,
        {
          yPercent: 20,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.7"
      )
      .staggerFrom(
        ".footer-useful-links ul li",
        0.5,
        {
          yPercent: -20,
          autoAlpha: 0,
          ease: Power4.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.6"
      )
      .from(
        ".copyright small",
        0.5,
        {
          yPercent: -20,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        "-=.6"
      );

    const controller = new ScrollMagic.Controller();

    if (mq.matches) {
      const scene = new ScrollMagic.Scene({
        triggerElement: ".footer-wrap",
        reverse: false,
        offset: -400,
      })
        .setTween(ft)
        .addTo(controller);
    } else {
      const scene = new ScrollMagic.Scene({
        triggerElement: ".footer-wrap",
        reverse: false,
        offset: -100,
      })
        .setTween(ft)
        .addTo(controller);
    }
  }

  public mounted() {
    this[FETCH_SOCIAL]();
    this[FETCH_SETTING]();
    this[FETCH_RMAIN_MENU]();
    if (window.matchMedia("(min-width: 1025px)").matches) {
      setTimeout(() => {
        this.footerAnim();
      }, 200);
    }
  }
}
